import { useNavigate } from 'react-router-dom';
import { GridCellParams } from '@mui/x-data-grid-pro';
import { CardButton } from '../../Buttons/CardButton';

// A row that is not itself an order but opens one passes orderId instead of its cell.
export type OrderDetailsCTARendererProps = { data: GridCellParams } | { orderId: string };

export function OrderDetailsCTARenderer(props: OrderDetailsCTARendererProps) {
  const navigate = useNavigate();
  const orderId = 'orderId' in props ? props.orderId : props.data.row?.id || String(props.data.id);

  return (
    <div className="mt-3">
      <CardButton
        data-testid="order-detail-cta-button"
        data-cy="order-detail-cta-button"
        onClick={() => navigate(`/orders/${orderId}`)}
        className="h-4"
        icon="details"
      />
    </div>
  );
}
